import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "statistic-card-group grid grid-cols-3 space-between mx-auto mt-16 gap-x-8 gap-y-4 xl:gap-x-16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-3xl xl:text-4xl font-bold col-span-3" }, " Adjudication Summary ", -1)
const _hoisted_3 = { class: "col-span-3 mt-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-3xl xl:text-4xl font-bold mb-4" }, "Recommendation Acceptance Rate", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticCard = _resolveComponent("StatisticCard")!
  const _component_RecommendationRate = _resolveComponent("RecommendationRate")!

  return (_ctx.statistics !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_StatisticCard, {
          id: "in-queue-card",
          label: "In Queue",
          value: _ctx.statistics.totalInQueue
        }, null, 8, ["value"]),
        _createVNode(_component_StatisticCard, {
          id: "responded-card",
          label: "Responded",
          value: _ctx.statistics.totalResponded
        }, null, 8, ["value"]),
        _createVNode(_component_StatisticCard, {
          id: "members-card",
          label: "Members",
          value: _ctx.statistics.totalMembers
        }, null, 8, ["value"]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_RecommendationRate, {
            id: "recommendation-rate",
            fraction: _ctx.statistics.followedRecommendations / _ctx.statistics.totalProcedures
          }, null, 8, ["fraction"])
        ])
      ]))
    : _createCommentVNode("", true)
}